export const alertConfig = {
    /**
    * --------------------------------------------------------------------------
    * Alert Configuration Language Lines
    * --------------------------------------------------------------------------
    *
    * The following language lines are used by Alert Configuration management system to build 
    * form, grid and other related places where tample related labels required.
    * You are free to change them to anything
    * you want to customize your views to better match your application.
    * 
    */
    en: {
        alert:"Alert",
        alert_configuration:"Alert Configuration",
        tampering:"Tampering",
        missing_payload:"Missing Payload",
        battery_critical:"Battery Critical",
        sms_alert:'SMS Alert',
        email_alert:'E-Mail Alert',
        yes:'Yes',
        no:'No',
        add:{
            success: 'Alert Configuration set successfully',
            error: 'Unable to set alert configuration. Please try again',
        }
    },

    ar: {
        alert:"إشعار",
        alert_configuration:"ضبط الاشعارات",
        tampering:"العبث",
        missing_payload:"الحمولة المفقودة",
        battery_critical:"البطارية على وشك النفاذ",
        sms_alert:'إخطار بالرسائل القصيرة',
        email_alert:'إخطار عبر البريد الالكتروني',
        yes:'نعم',
        no:'لا',
        add:{
            success: 'تمت التعديلات بنجاح',
            error: 'تعذرت التعديلات، حاول مرة أخرى',
        }
    }
}